<app-dialog-header
  [title]="editBatch ? 'Editar Lote' : selectedTicket !== undefined ? 'Editar Ingresso' : 'Criar Novo Ingresso'">
</app-dialog-header>

<mat-dialog-content>
  <div class="container modal-ticket-free" id="modalTicketFree">
    <form [formGroup]="ticketsForm" (ngSubmit)="saveTicket()">
      <div class="d-flex flex-column justify-content-between p-3">
        @if (editBatch) {
          <div>
            <div>
              <p class="h4 title">Lotes de ingressos</p>
              <p class="p text-secondary">
                Organize suas vendas por lote. Defina a data e hora de início e término para cada lote.
              </p>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <div class="dropdown-batch">
                  <p-select
                    formControlName="selectedBatch"
                    [placeholder]="'Lote ' + (ticketsForm.value.selectedBatch + 1)"
                    [options]="optionsSelectBatch"
                    optionLabel="name"
                    [(ngModel)]="ticketsForm.value.selectedBatch"
                    (ngModelChange)="onBatchChange($event)" />
                </div>
                @if (ticketsForm.get("selectedBatch")?.invalid && ticketsForm.get("selectedBatch")?.touched) {
                  <div class="invalid-feedback">Por favor selecione o lote.</div>
                }
                <div class="my-3">
                  <label for="transitionModeLegacy" class="form-label">Virada do lote</label>
                  <select id="transitionModeLegacy" class="form-select" formControlName="transitionMode">
                    <option value="date_or_sold_out">Por data ou esgotamento</option>
                    <option value="sold_out_only">Somente por esgotamento</option>
                  </select>
                  @if (soldOutOnly) {
                    <p class="p text-secondary">Lotes online: até esgotar ou até o início do evento. Portaria: no máximo até o fim do evento.</p>
                  }
                  @if (soldOutOnly && !openingEditable) {
                    <p class="p text-secondary">Aguarda o lote anterior encerrar.</p>
                  }
                </div>
                <div class="row" formGroupName="ticketsDateGroup">
                  @if (openingEditable) {
                    <div class="">
                      <div class="mb-3">
                        <label for="start_date" class="form-label">Data e Hora Início</label>
                        <div class="input-group">
                          <input
                            id="start_date"
                            formControlName="start_date"
                            type="date"
                            class="form-control"
                            [class.is-invalid]="
                              ticketsForm.get('start_date')?.invalid && ticketsForm.get('start_date')?.touched
                            " />
                          <input
                            id="start_time"
                            formControlName="start_time"
                            type="time"
                            class="form-control"
                            [class.is-invalid]="
                              ticketsForm.get('start_time')?.invalid && ticketsForm.get('start_time')?.touched
                            " />
                        </div>
                      </div>
                    </div>
                  }
                  @if (!soldOutOnly) {
                    <div class="">
                      <label for="end_date" class="form-label">Data e Hora Término</label>
                      <div class="input-group">
                        <input
                          id="end_date"
                          formControlName="end_date"
                          type="date"
                          class="form-control"
                          [class.is-invalid]="
                            ticketsForm.get('end_date')?.invalid && ticketsForm.get('end_date')?.touched
                          " />
                        <input
                          id="end_time"
                          formControlName="end_time"
                          type="time"
                          class="form-control"
                          [class.is-invalid]="
                            ticketsForm.get('end_time')?.invalid && ticketsForm.get('end_time')?.touched
                          " />
                      </div>
                      @if (ticketsForm.get("end_date")?.invalid && ticketsForm.get("end_date")?.touched) {
                        <div class="invalid-feedback">Data de término é obrigatória.</div>
                      }
                      @if (ticketsForm.get("end_time")?.invalid && ticketsForm.get("end_time")?.touched) {
                        <div class="invalid-feedback">Hora de término é obrigatória.</div>
                      }
                      @if (
                        ticketsForm.get("ticketsDateGroup")?.errors?.["dateEndBeforeStart"] &&
                        ticketsForm.get("ticketsDateGroup")?.touched
                      ) {
                        <div class="text-danger">A data de término não pode ser antes da data de início.</div>
                      }
                    </div>
                  }
                </div>

                @if (!isTicketFree) {
                  <div class="batch-options mt-3">
                    <p class="batch-options__heading">Taxas e canais de venda</p>

                    <div class="batch-options__item">
                      <div>
                        <label class="batch-options__title" for="absorbPlatformFeeBatch">
                          Absorver taxa da plataforma
                        </label>
                        <p class="batch-options__description">
                          O produtor absorve a taxa da plataforma, sem acrescentá-la ao preço pago pelo cliente.
                        </p>
                      </div>
                      <div class="form-check form-switch m-0">
                        <input
                          id="absorbPlatformFeeBatch"
                          class="form-check-input batch-options__switch"
                          type="checkbox"
                          role="switch"
                          formControlName="absorbsPlatformFee" />
                      </div>
                    </div>

                    <div class="batch-options__item">
                      <div>
                        <label class="batch-options__title" for="absorbProcessingFeeBatch">
                          Absorver taxa de processamento
                        </label>
                        <p class="batch-options__description">
                          O produtor assume a taxa cobrada pelo processamento do pagamento.
                        </p>
                      </div>
                      <div class="form-check form-switch m-0">
                        <input
                          id="absorbProcessingFeeBatch"
                          class="form-check-input batch-options__switch"
                          type="checkbox"
                          role="switch"
                          formControlName="absorbsProcessingFee" />
                      </div>
                    </div>

                    <div class="batch-options__item">
                      <div>
                        <label class="batch-options__title" for="soldAtPdvBatch">Vender no PDV Evento</label>
                        <p class="batch-options__description">
                          Disponibiliza os ingressos deste lote para venda no PDV Evento.
                        </p>
                      </div>
                      <div class="form-check form-switch m-0">
                        <input
                          id="soldAtPdvBatch"
                          class="form-check-input batch-options__switch"
                          type="checkbox"
                          role="switch"
                          formControlName="soldAtPdv" />
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }

        <div>
          @if (ticketsForm.get("ticketsDateGroup")?.hasError("closingAfterEventStart")) {
            <div class="text-danger">O término das vendas online deve ser no máximo até o início do evento.</div>
          }
          @if (ticketsForm.get("start_date")?.invalid && ticketsForm.get("start_date")?.touched) {
            <div class="invalid-feedback">Data de início é obrigatória.</div>
          }
          @if (ticketsForm.get("start_time")?.invalid && ticketsForm.get("start_time")?.touched) {
            <div class="invalid-feedback">Hora de início é obrigatória.</div>
          }
          @if (
            ticketsForm.get("ticketsDateGroup")?.errors?.["dateBeforeCurrent"] &&
            ticketsForm.get("ticketsDateGroup")?.touched
          ) {
            <div class="text-danger">
              As datas de início e/ou término da venda de ingressos não podem ser antes da data atual.
            </div>
          }
          @if (
            ticketsForm.get("ticketsDateGroup")?.errors?.["startDateAfterEventEnd"] &&
            ticketsForm.get("ticketsDateGroup")?.touched
          ) {
            <div class="text-danger">A data de início da venda de ingressos não pode ser após o término do evento.</div>
          }
          @if (
            ticketsForm.get("ticketsDateGroup")?.errors?.["endDateAfterEventEnd"] &&
            ticketsForm.get("ticketsDateGroup")?.touched
          ) {
            <div class="text-danger">
              A data de término da venda de ingressos não pode ser após o término do evento.
            </div>
          }
          @if (
            ticketsForm.get("ticketsDateGroup")?.errors?.["datesAreEqual"] &&
            ticketsForm.get("ticketsDateGroup")?.touched
          ) {
            <div class="text-danger">As datas das vendas de ingressos não podem ser iguais.</div>
          }
        </div>

        <div>
          @if (ticketsForm.get("end_date")?.invalid && ticketsForm.get("end_date")?.touched) {
            <div class="invalid-feedback">Data de término é obrigatória.</div>
          }
          @if (ticketsForm.get("end_time")?.invalid && ticketsForm.get("end_time")?.touched) {
            <div class="invalid-feedback">Hora de término é obrigatória.</div>
          }
          @if (
            ticketsForm.get("ticketsDateGroup")?.errors?.["dateEndBeforeStart"] &&
            ticketsForm.get("ticketsDateGroup")?.touched
          ) {
            <div class="text-danger">A data de término não pode ser antes da data de início.</div>
          }
        </div>

        @if (!editBatch) {
          <div>
            <div>
              <p class="h4">Informações do Ingresso</p>
              <p class="p text-secondary">
                Forneça um nome claro e uma descrição atrativa. Defina a quantidade disponível e o preço por ingresso
              </p>
            </div>
            <div class="row">
              <div class="col-sm-6 col-md-6 col-lg-4">
                <label for="ticketTitle" class="form-label">Nome do Ingresso</label>
                <input
                  id="ticketTitle"
                  formControlName="ticketTitle"
                  type="text"
                  class="form-control"
                  [class.is-invalid]="
                    ticketsForm.get('ticketTitle')?.invalid && ticketsForm.get('ticketTitle')?.touched
                  " />
                @if (ticketsForm.get("ticketTitle")?.invalid && ticketsForm.get("ticketTitle")?.touched) {
                  <div class="invalid-feedback">Nome do ingresso é obrigatório.</div>
                }
              </div>
              <div class="col-sm-6 col-md-6 col-lg-4">
                <label for="quantity" class="form-label">Quantidade</label>
                <input
                  id="quantity"
                  formControlName="quantity"
                  type="number"
                  class="form-control"
                  [class.is-invalid]="ticketsForm.get('quantity')?.invalid && ticketsForm.get('quantity')?.touched" />
                @if (ticketsForm.get("quantity")?.invalid && ticketsForm.get("quantity")?.touched) {
                  <div class="invalid-feedback">Quantidade é obrigatória e deve ser maior que 0.</div>
                }
              </div>
              <div class="col-sm-6 col-md-6 col-lg-4">
                <label for="price" class="form-label">Valor do ingresso</label>
                <input
                  id="price"
                  formControlName="price"
                  type="number"
                  min="0"
                  step="0.01"
                  class="form-control"
                  [class.is-invalid]="ticketsForm.get('price')?.invalid && ticketsForm.get('price')?.touched"
                  placeholder="GRÁTIS" />
                @if (ticketsForm.get("price")?.invalid && ticketsForm.get("price")?.touched) {
                  <div class="invalid-feedback">Informe zero para gratuito ou pelo menos R$ 1,00.</div>
                }
                @if (!isTicketFree) {
                  <div class="d-flex gap-2 mt-1" [title]="getTaxString()">
                    <label>Valor final</label>
                    <p class="p text-success">{{ getFinalPriceString() | currency: "BRL" }}</p>
                  </div>
                }
              </div>
            </div>

            <div class="row p-2">
              <label for="ticketDescription" class="">Descrição do ingresso</label>

              <textarea
                pTextarea
                name="ticketDescription"
                id="ticketDescription"
                cols="20"
                rows="5"
                placeholder="Digite a descrição do ingresso"
                formControlName="ticketDescription"
                [class.is-invalid]="
                  ticketsForm.get('ticketDescription')?.invalid && ticketsForm.get('ticketDescription')?.touched
                "></textarea>
              @if (ticketsForm.get("ticketDescription")?.invalid && ticketsForm.get("ticketDescription")?.touched) {
                <div class="invalid-feedback">A descrição é obrigatória.</div>
              }
            </div>

            <div class="row mt-3 mb-3">
              <div>
                <p class="h4 title">Quantidade permitida por compra</p>
                <p class="p text-secondary">
                  Estabeleça o número mínimo e máximo de ingressos que cada comprador pode adquirir por transação.
                </p>
              </div>
              <div class="col">
                <label for="minTickets" class="form-label">Mínimo</label>
                <input
                  id="minTickets"
                  formControlName="minTickets"
                  type="number"
                  class="form-control"
                  [class.is-invalid]="
                    ticketsForm.get('minTickets')?.invalid && ticketsForm.get('minTickets')?.touched
                  " />
                @if (ticketsForm.get("minTickets")?.invalid && ticketsForm.get("minTickets")?.touched) {
                  <div class="invalid-feedback">Quantidade é obrigatória e deve ser maior que 0.</div>
                }
              </div>
              <div class="col">
                <label for="maxTickets" class="form-label">Máximo</label>
                <input
                  id="maxTickets"
                  formControlName="maxTickets"
                  type="number"
                  class="form-control"
                  [class.is-invalid]="
                    ticketsForm.get('maxTickets')?.invalid && ticketsForm.get('maxTickets')?.touched
                  " />
                @if (
                  ticketsForm.get("maxTickets")?.errors?.["maxTicketsIsZero"] && ticketsForm.get("maxTickets")?.touched
                ) {
                  <div class="invalid-feedback">Quantidade é obrigatória e deve ser maior que 0.</div>
                }
                @if (
                  ticketsForm.get("maxTickets")?.errors?.["maxTicketsExceededQuantity"] &&
                  ticketsForm.get("maxTickets")?.touched
                ) {
                  <div class="invalid-feedback">
                    A quantidade máxima de tickets não pode ser maior que a disponível.
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </form>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="gap-2">
  <app-button styleType="secondary" (click)="closeModal()">Cancelar</app-button>
  <app-button type="submit" (click)="saveTicket()">Salvar</app-button>
</mat-dialog-actions>
